import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LoanCalculator from "@/pages/LoanCalculator";
import ResultsPage from "@/pages/ResultsPage";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Detect session_id in URL fragment (from Emergent Google Auth callback)
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LoanCalculator />} />
      <Route path="/results" element={<ResultsPage />} />
      <Route path="/admin-momento-secure-2024" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App" dir="rtl">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
